import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { get, find } from 'lodash';
import isEmpty from 'lodash/isEmpty';
import { FareFieldMapping } from '../../constants/index';
import InfoCard from '../InfoCard/InfoCard';

import './BillDetails.scss';

class BillDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      includeReport: false,
    };
  }

  getLPCashbackDetails = () =>
    (
      find(get(this.props, 'cashbackDetails.desc', []), {
        key: 'lp_cashback',
      }) || {}
    ).value || null;

  renderCartValueBreakup = cartFareData => {
    const filteredCartFareData = !cartFareData ? [] : cartFareData;
    return filteredCartFareData.map(fareDetail => {
      if (isEmpty(fareDetail) || !fareDetail.displayTextKey) {
        return null;
      }
      const {
        isNegativeValue,
        discountedAmount: fareAmount,
        subTextInfo,
        displayTextKey,
        amount: originalAmount,
      } = fareDetail || {};
      const fareDisplayText = FareFieldMapping[displayTextKey];
      const isSampleCollectionField = fareDisplayText === FareFieldMapping.sample_collection;
      const isPharmeasyWallet = fareDisplayText === FareFieldMapping.pharmeasy_wallet;
      return (
        <div className="itemContainer-bd" key={displayTextKey}>
          <div className={`fareTitle ${isNegativeValue ? 'greenText' : ''}`}>{fareDisplayText}
            {isPharmeasyWallet && (
            <InfoCard
              infoCard={[
                {
                  header: 'Cashback',
                  text: 'Cashback can be used to pay only 50% of your order value',
                },
                {
                  header: 'Refund Cash',
                  text: 'Entire Refund cash can be used to pay for your order',
                },
              ]}
            />
            )}</div>
          <div className={`${(isNegativeValue || isSampleCollectionField) ? 'greenText' : ''}`}>
            {isNegativeValue && <span>-&nbsp;</span>}
            {isSampleCollectionField && originalAmount >= 0 && (
              <span>
                <span
                  className={`${isSampleCollectionField ? 'strikeOff' : ''}`}
                >
                  &#8377;{originalAmount}
                </span>
                <span>&nbsp;</span>
              </span>
            )}
            {(fareAmount >= 0) && <span>&#8377;{fareAmount}</span>}
            {(!isSampleCollectionField && subTextInfo) && <span>&nbsp;({subTextInfo})</span>}
          </div>
        </div>
      );
    });
  }

  render() {
    const { cartFareData } = this.props;
    return (
      <div className="billDetails-bd">
        {this.renderCartValueBreakup(cartFareData)}
        {this.getLPCashbackDetails() && (
          <div className="itemContainer-bd">
            <div className="textTitle-bd">
              PharmEasy <b>PLUS</b> Cashback
            </div>
            <div className="textBigger-bd textGrn-bd">
              &#8377; {this.getLPCashbackDetails()}
            </div>
          </div>
        )}
      </div>
    );
  }
}

BillDetails.propTypes = {
  cartFareData: PropTypes.array,
};

BillDetails.defaultProps = {
  cartFareData: [],
};

export default BillDetails;
